import SubcontractorRateChartEdit from "./SubcontractorRateChartsEdit";
import SubcontractorRateChartShow from "./SubcontractorRateChartsShow";
import SubcontractorRateChartsCreate from "./SubcontractorRateChartsCreate";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  name: "SubcontractorRateCharts",
  show: SubcontractorRateChartShow,
  edit: SubcontractorRateChartEdit,
  create: SubcontractorRateChartsCreate,
};
